import React, { useState, useEffect } from "react";
import Multiselect from "react-widgets/Multiselect";

// REDUX
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { addLabel, addLabelLocal, removeLabel, removeLabelLocal, fetchLabels } from "../../../redux/actions/analysisActions";

const LabelsMultiSelect = (props) => {
  const dispatch = useDispatch();

  const addLabel_rd = (item) => dispatch(addLabel(item));
  const addLabelLocal_rd = (item) => dispatch(addLabelLocal(item));
  const removeLabel_rd = (item) => dispatch(removeLabel(item));
  const removeLabelLocal_rd = (item) => dispatch(removeLabelLocal(item));
  // REDUX STATES
  const analysis_id = useSelector((state) => (state.analysis.analysis_id ? state.analysis.analysis_id : null));
  const labels = useSelector((state) => (state.analysis.labels ? state.analysis.labels : null));
  const product_labels = useSelector(
    (state) => (state.analysis.analysis_data && state.analysis.analysis_data.labels ? state.analysis.analysis_data.labels : null),
    shallowEqual
  );
  const fetchLabels_rd = () => dispatch(fetchLabels());

  // FETCH LABELS
  useEffect(() => {
    const fetchLabel_fn = async () => {
      await fetchLabels_rd();
    };
    if (!labels) {
      fetchLabel_fn();
    }
  }, []);

  const handleAddLabel = async (value) => {
    const item = {
      analysis_id: analysis_id,
      label: value,
      type: "add_label",
    };
    const label_remote_key = await addLabelLocal_rd(item);
    item.label_remote_key = label_remote_key;
    addLabel_rd(item);
  };

  const handleRemoveLabel = async (value) => {
    const value_ids = value.map((x) => x.id);
    const removed = Object.entries(product_labels).filter((x) => !value_ids.includes(x[1].id));
    const item = {
      analysis_id: analysis_id,
      label: removed[0][1],
      label_remote_key: removed[0][0],
      type: "remove_label",
    };
    await removeLabelLocal_rd(item);
    removeLabel_rd(item);
  };

  const handleChangeLabels = async (value) => {
    if (product_labels) {
      if (Object.values(product_labels).length < value.length) {
        handleAddLabel(value.slice(-1)[0]);
      } else {
        handleRemoveLabel(value);
      }
    } else {
      handleAddLabel(value.slice(-1)[0]);
    }
  };

  return (
    <>
      <div className="h-[50px] flex items-center w-[563px]">
        <p className="font-Poppins-SemiBold m-[5px] mx-[0px]">Labels</p>
        <Multiselect // disabled={product_labels}
          className="w-[450px] ml-[10px] bg-white"
          onChange={handleChangeLabels} // onSelect={handleChangeSelectLabel}
          placeholder={props.is_reduce ? "Aucun label ajouté" : "Ajouter des labels..."}
          value={product_labels ? Object.values(product_labels) : []}
          data={labels ? labels : []}
          textField="name"
          filter="contains"
          disabled={props.is_reduce}
        />
        {/* <p onClick={() => {
          console.log(labels, product_labels)
        }}>
          TOTO
        </p> */}
      </div>
    </>
  );
};

export default LabelsMultiSelect;
